var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownPlacementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 140,
    viewBox: "0 0 183 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32H163V108H20V32Z",
    fill: "#EFEEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5559 72.28C92.3133 72.28 92.9853 72.392 93.5719 72.616C94.1586 72.84 94.6173 73.1707 94.9479 73.608C95.2786 74.0347 95.4439 74.5627 95.4439 75.192C95.4439 75.832 95.3053 76.36 95.0279 76.776C94.7613 77.1813 94.3986 77.4907 93.9399 77.704C93.4813 77.9067 92.9746 78.04 92.4199 78.104L92.3079 79.608H90.3079L90.3239 77.192C91.0386 77.1067 91.5933 76.9947 91.9879 76.856C92.3933 76.7067 92.6759 76.52 92.8359 76.296C93.0066 76.072 93.0919 75.8053 93.0919 75.496C93.0919 75.1973 93.0279 74.9467 92.8999 74.744C92.7826 74.5413 92.6013 74.3867 92.3559 74.28C92.1106 74.1733 91.7959 74.12 91.4119 74.12C90.8573 74.12 90.4146 74.28 90.0839 74.6C89.7533 74.9093 89.5506 75.352 89.4759 75.928L87.3959 75.128C87.5239 74.5733 87.7586 74.0827 88.0999 73.656C88.4413 73.2187 88.8946 72.8827 89.4599 72.648C90.0359 72.4027 90.7346 72.28 91.5559 72.28ZM91.3319 80.68C91.7479 80.68 92.0786 80.792 92.3239 81.016C92.5693 81.24 92.6919 81.5387 92.6919 81.912C92.6919 82.296 92.5693 82.6 92.3239 82.824C92.0786 83.0373 91.7479 83.144 91.3319 83.144C90.9159 83.144 90.5853 83.0373 90.3399 82.824C90.0946 82.6 89.9719 82.296 89.9719 81.912C89.9719 81.5387 90.0946 81.24 90.3399 81.016C90.5853 80.792 90.9159 80.68 91.3319 80.68Z",
    fill: "#6E28FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 143,
    height: 16,
    fill: "#DAD8DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownPlacementIcon);
export default __webpack_public_path__ + "static/media/unknown-placement-icon.744509096aeb4b149be83d32c1240628.svg";
export { ForwardRef as ReactComponent };